module.exports = __webpack_public_path__ + "img/certificate-4.b35a04b6.png";